import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { isAuthenticated as checkAuthenticated } from '../utilities/authentication';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';

const Router = () => {
  const isAuthenticated = checkAuthenticated();

  const router = createBrowserRouter([
    isAuthenticated ? PrivateRoute() : {},
    ...PublicRoute(),
  ]);

  return <RouterProvider router={router} />;
};

export default Router;
